<template>
  <dialog-form
    :value="value"
    @input="$emit('input', $event)"
    :title="$localize('RenameAttribute.title')"
    :allow-continue="false"
    @commit="save"
  >
    <v-text-field
      :label="$localize('Attribute.displayName')"
      v-model="renameAttribute.newDisplayName"
      prepend-icon="mdi-text"
      autofocus
      :rules="[validation.required, validation.maxLength(50)]"
    />
  </dialog-form>
</template>

<script>
import DialogForm from "@/shared/components/DialogForm";
import sendCommand from "@/services/sendCommand";
import { required, maxLength } from "@/services/validation";
export default {
  components: { DialogForm },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    alias: {
      type: String
    },
    displayName: {
      type: String
    }
  },

  data() {
    return {
      renameAttribute: {
        newDisplayName: this.displayName
      },
      validation: { required, maxLength },
    };
  },

  watch: {
    displayName(val) {
      this.renameAttribute.newDisplayName = val;
    }
  },

  methods: {
    async save(callback) {
      this.renameAttribute.alias = this.alias;
      const result = await sendCommand("RenameAttribute", this.renameAttribute);

      if (result.success) {
        this.$emit("saved");
      }

      callback({ success: result.success });
    }
  }
};
</script>
